// Libraries
import styled from 'styled-components';

export const ExportContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PeriodSelectorContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  };
`;

export const DatePickerWrapper = styled.div`
  width: auto;

  @media (max-width: 768px) {
    width: 100%;
  };
`;

export const PresetsWrapper = styled.div`
  width: auto;

  @media (max-width: 768px) {
    width: 100%;
  };
`;

export const HelperText = styled.div`
  margin-top: -2px;
  width: max-content;
`;

export const TaskStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 1rem 0;
  border-radius: 8px;
  background-color: ${({ theme }): string => theme.color.crusherDashboard.modulesBackgroundColor};
`;

export const ErrorDetails = styled.details`
  margin-top: 0.5rem;
  font-size: 12px;
  opacity: 0.7;
`;

export const ErrorSummary = styled.summary`
  cursor: pointer;
`;

export const ErrorPre = styled.pre`
  margin-top: 4px;
  white-space: pre-wrap;
  font-size: 11px;
`;
